import { Effect } from 'effect'
import { FileReadError } from './archive-errors'
import type { FileEntry } from './file-entry'

/**
 * Browser files cross into managed code through this adapter. The rest of the
 * archive pipeline sees an Effect description and never calls a Promise API.
 */
export function readBrowserFile(file: Blob): Effect.Effect<Uint8Array, FileReadError> {
  return Effect.tryPromise({
    try: () => file.arrayBuffer(),
    catch: (cause) => new FileReadError({ cause })
  }).pipe(Effect.map((buffer) => new Uint8Array(buffer)))
}

export function browserFileEntry(path: string, file: File): FileEntry {
  return {
    path,
    file,
    readBytes: readBrowserFile(file)
  }
}
